import type { RouteObject } from 'react-router-dom';

import { StubPage } from '@/app/pages/StubPage';
import { defineHandle } from '@/app/routes/types';

import { settingsAccessRoles } from './access';

export const settingsRoutes: RouteObject[] = [
  {
    path: 'settings',
    element: <StubPage titleKey="nav.settings" dataPage="settings/index" />,
    handle: defineHandle({
      roles: [...settingsAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.settings',
    }),
  },
];
